import React, { useState, useEffect } from 'react';

import { isTokenPresent } from '../utils/auth';
import { DocumentModel } from '../utils/Interface/DocumentModel';
import useSpecialToken from '../utils/hooks/useSpecialToken';
import apiRoutes from '../utils/hooks/apiRoutes';

import TabsNav from '../components/TabsNav';
import Menu from '../components/Menu';
import Header from '../components/Header';
import Button from '../components/Button';
import TableSimpleModel from '../components/TableSimpleModel';

import '../style/css/doccategoryconfig.css';

const DocModelConfig: React.FC = () => {

  const { userName, specialToken } = useSpecialToken();
  const [data, setData] = useState<DocumentModel[]>([]);

//functions useEffect & fetchData

  useEffect(() => {
    if (!isTokenPresent()) {
      window.location.href = '/';
    } else if (specialToken) {
      fetchData(specialToken);
    }
  }, [specialToken]);

  const fetchData = async (token: string) => {

    try {
      const headers = {
        'Content-Type': 'application/json',
        'special-token': token
      };

      const response = await fetch(apiRoutes.documentsModelsGetAll, { headers });

      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des données');
      }

      const jsonData = await response.json();
      setData(jsonData);

    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    }

  };

  const handleNewModel = () => {
    window.location.href = '/configuration/documents/modeles/nouveau';
  };

  return (

    <div className="maindcc">

      <div className="maindcc__box1">

        <Header userName={userName} />

        <div className="maindcc__box1__container">

          <h2 className="maindcc__box1__container__title"> Configuration documents</h2>

          <div className='maindcc__box1__container__div'>

            <TabsNav tab1="Catégorie" tab2="Modèle" path1="/configuration/documents/categories" path2="/configuration/documents/modeles" />

            <div className="maindcc__box1__container__btn">
              <Button btnName="Nouveau" onClick={handleNewModel} disable={false} />
            </div>
          </div>

          <div className="maindcc__box1__container__list">
            <TableSimpleModel models={data} onEdit={handleNewModel} />
          </div>

        </div>

      </div>

      <div className="maindcc__menu">

        <Menu />

      </div>
      
    </div>
  );
};

export default DocModelConfig;
